import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Junctions from "./List";
import AddJunctions from "./AddJunction";
import {
  LicenseTypes,
  Operation,
  PageFor,
} from "../../../../../../utils/Enum.types";
import JunctionsItemList from "./JunctionsItemList";
import ViewJunctions from "./viewjunctions";

const JunctionRoutes = () => {
  const [modalFlag, setModalFlag] = useState(false);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Junctions setModalFlag={setModalFlag} pageType={PageFor.GENERAL} />
        }
      />
      <Route path="/view" element={<ViewJunctions />} />
      <Route
        path="/:junctionID/*"
        element={
          <Routes>
            <Route
              path="/update"
              element={
                <AddJunctions
                  setModalFlag={setModalFlag}
                  operation={Operation.UPDATE}
                />
              }
            />
            <Route
              path="/itemslist"
              element={
                <JunctionsItemList
                  pageType={PageFor.GENERAL}
                  NavType={LicenseTypes.SUBSIDIARY}
                  setModalFlag={setModalFlag}
                />
              }
            />
          </Routes>
        }
      />
    </Routes>
  );
};

export default JunctionRoutes;
